import { Entitlements } from '@ninety/platform/models/entitlements/entitlements-model';

export interface EntitlementsState {
  entitlements: Entitlements;
}

export const InitialEntitlementsState: EntitlementsState = {
  entitlements: {
    scopes: [],
  } as Entitlements,
};
